import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route404Component } from '@app/route404/route404.component';
import { LogoutComponent } from '@app/auth/logout.component';
import { LoginComponent } from '@app/auth/login.component';

export const routes: Routes = [
    {
        path: 'dashboard',
        loadChildren: './detailed/detailed.module#DetailedModule',
        data: {
            title: 'Dashboard',
            locationSelector: true,
        },
    },
    {
        path: 'notifications',
        loadChildren: './notifications/notifications.module#NotificationsModule',
        data: {
            title: 'Notifications',
            locationSelector: true,
        },
    },
    {
        path: 'settings',
        loadChildren: './settings/settings.module#SettingsModule',
        data: {
            title: 'Settings',
            locationSelector: true,
        },
    },
    {
        path: 'local-pro',
        loadChildren: './angi/angi.module#AngiModule',
        data: {
            title: 'Find a Local Pro',
            locationSelector: true,
        },
    },
    {
        path: 'events',
        loadChildren: './event-review/event-review.module#EventReviewModule',
        data: {
            title: 'Event Review',
            locationSelector: true,
        },
    },
    {
        path: 'logout',
        component: LogoutComponent,
    },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: '',
        component: LoginComponent,
    },
    {
        path: '**',
        component: Route404Component,
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
